import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { UsersService } from '../users.service';
import { MessageService } from 'primeng/api';
import { first } from "rxjs/operators";

@Component({
    selector: 'app-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.css'],
    providers: [UsersService, MessageService]
})
export class RegistrationComponent implements OnInit {
    registrationForm = this.fb.group({
        firstName: ['', [Validators.required]],
        lastName: ['', [Validators.required]],
        phone: ['', [Validators.required]],
        email: ['', [Validators.required, Validators.email]],
        toc: ['', [Validators.requiredTrue]],
    });

    displayModal: boolean;
    waitingResponse = false;

    constructor(
        private fb: FormBuilder,
        private userService: UsersService,
        private messageService: MessageService) { }

    ngOnInit(): void { }

    showModalDialog() {
        this.displayModal = true;
    }

    submitForm() {
        this.registrationForm.markAllAsTouched();
        this.registrationForm.updateValueAndValidity();

        if (!this.registrationForm.valid) {
            return;
        }

        const userData = {
            firstname: `${this.registrationForm.get('firstName').value}`,
            lastname: `${this.registrationForm.get('lastName').value}`,
            email: `${this.registrationForm.get('email').value}`,
            phone: `${this.registrationForm.get('phone').value}`
        }

        this.waitingResponse = true;
        this.userService.submitUser(userData)
            .pipe(
                first()
            )
            .subscribe(res => {
                this.registrationForm.reset();
                this.waitingResponse = false;
                this.messageService.add({ severity: 'success', summary: 'Συγχαρητήρια!', detail: 'Η εγγραφή σας ολοκληρώθηκε επιτυχώς' });
            },
            error => {
                this.waitingResponse = false;
                this.messageService.add({ severity: 'error', summary: 'Σφάλμα!', detail: 'Το email έχει ήδη καταχωρηθεί' });
            })
    }
}

